import { render, staticRenderFns } from "./UserChatList.vue?vue&type=template&id=5bb7ae5e&"
import script from "./UserChatList.vue?vue&type=script&lang=js&"
export * from "./UserChatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports